import { render, staticRenderFns } from "./DashboardCxC.vue?vue&type=template&id=d4990538&scoped=true"
import script from "./DashboardCxC.vue?vue&type=script&lang=js"
export * from "./DashboardCxC.vue?vue&type=script&lang=js"
import style0 from "./DashboardCxC.vue?vue&type=style&index=0&id=d4990538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4990538",
  null
  
)

export default component.exports